// extracted by mini-css-extract-plugin
export default {"calendardatescreen":"CalendarDateScreen_calendardatescreen__eS4Jk"};